module.exports = __webpack_public_path__ + "static/media/name.741f12b7.png";